import * as Yup from "yup";

export const generateInitialValues = (questions) => {
  return questions.map((question) => ({
    question: question.question,
    answer: "",
    experience: "",
    rating: 0,
  }));
};

export const generateSchema = (questions) => {
  return Yup.array().of(
    Yup.object({
      answer: Yup.string()
        .required("Answer is required.")
        .min(
          2,
          `Answer must be at least 2 characters.`
        ),
      experience: Yup.string(),
        // .required("Experience is required.")
        // .min(5, "Experience must be at least 5 characters."),
      rating: Yup.number()
        .required("Rating is required.")
        .min(1, "Rating must be at least 1.")
        // .max(5, "Rating cannot exceed 5."),
    })
  );
};
